import React from 'react';
import { Link } from 'react-router-dom';
import { PlayIcon, ZapIcon, TargetIcon, TrendingUpIcon, CheckCircleIcon, SparklesIcon, LayersIcon, ClockIcon } from 'lucide-react';
export function GTMPlaysPage() {
  return <div className="w-full bg-white" data-id="element-7014">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-violet-900 via-purple-800 to-fuchsia-900 text-white py-24 overflow-hidden" data-id="element-7015">
        <div className="absolute inset-0 bg-grid-white/[0.05] bg-[size:20px_20px]" data-id="element-7016" />
        <div className="absolute inset-0" data-id="element-7017">
          <div className="absolute top-20 left-10 w-72 h-72 bg-violet-500/20 rounded-full blur-3xl animate-pulse" data-id="element-7018" />
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-fuchsia-500/20 rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-7019" />
        </div>
        <div className="max-w-7xl mx-auto px-6 relative" data-id="element-7020">
          <div className="max-w-4xl mx-auto text-center" data-id="element-7021">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-violet-500/20 rounded-full border border-violet-400/30 mb-6" data-id="element-7022">
              <PlayIcon className="w-4 h-4" data-id="element-7023" />
              <span className="text-sm font-medium" data-id="element-7024">Pre-Built GTM Motions</span>
            </div>
            <h1 className="text-6xl font-bold mb-6 leading-tight" data-id="element-7025">GTM Plays</h1>
            <p className="text-xl text-violet-100 mb-8 leading-relaxed" data-id="element-7026">
              Pre-built, proven GTM motions you can deploy in minutes. Each play
              includes triggers, workflows, content, and success metrics.
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-7027">
              <Link to="/signup" className="px-8 py-4 bg-white text-violet-900 rounded-lg hover:bg-violet-50 font-medium text-lg shadow-lg hover:shadow-xl transition-all" data-id="element-7028">
                Browse Plays
              </Link>
              <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-7029">
                Schedule Demo
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* What GTM Plays Are */}
      <section className="py-24 bg-white" data-id="element-7030">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7031">
          <div className="text-center mb-16" data-id="element-7032">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7033">
              What GTM Plays are
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-7034">
              Plays are complete, ready-to-run GTM motions. Think of them as
              recipes: they include the trigger, steps, content, and metrics
              needed to execute.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-7035">
            <div className="bg-gradient-to-br from-violet-50 to-violet-100 rounded-xl p-6 border-2 border-violet-200" data-id="element-7036">
              <div className="w-14 h-14 bg-violet-600 rounded-xl flex items-center justify-center mb-4" data-id="element-7037">
                <ZapIcon className="w-7 h-7 text-white" data-id="element-7038" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7039">
                Trigger logic
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-7040">
                When and why the play runs
              </p>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6 border-2 border-purple-200" data-id="element-7041">
              <div className="w-14 h-14 bg-purple-600 rounded-xl flex items-center justify-center mb-4" data-id="element-7042">
                <LayersIcon className="w-7 h-7 text-white" data-id="element-7043" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7044">
                Step-by-step workflow
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-7045">
                Exact sequence of actions
              </p>
            </div>
            <div className="bg-gradient-to-br from-fuchsia-50 to-fuchsia-100 rounded-xl p-6 border-2 border-fuchsia-200" data-id="element-7046">
              <div className="w-14 h-14 bg-fuchsia-600 rounded-xl flex items-center justify-center mb-4" data-id="element-7047">
                <SparklesIcon className="w-7 h-7 text-white" data-id="element-7048" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7049">
                Content & templates
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-7050">
                Pre-written copy and assets
              </p>
            </div>
            <div className="bg-gradient-to-br from-pink-50 to-pink-100 rounded-xl p-6 border-2 border-pink-200" data-id="element-7051">
              <div className="w-14 h-14 bg-pink-600 rounded-xl flex items-center justify-center mb-4" data-id="element-7052">
                <TrendingUpIcon className="w-7 h-7 text-white" data-id="element-7053" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7054">
                Success metrics
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-7055">
                KPIs and benchmarks
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Popular Plays */}
      <section className="py-24 bg-gray-50" data-id="element-7056">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7057">
          <div className="text-center mb-16" data-id="element-7058">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7059">
              Popular GTM Plays
            </h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-7060">
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-7061">
              <div className="flex items-start justify-between mb-4" data-id="element-7062">
                <div data-id="element-7063">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7064">
                    High-Intent Account Blitz
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-7065">
                    Multi-channel • 8 touchpoints • 14 days
                  </p>
                </div>
                <span className="px-3 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-full" data-id="element-7066">
                  Top Performer
                </span>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-7067">
                Target accounts showing 3+ buying signals with coordinated
                email, LinkedIn, and phone outreach.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-7068">
                <div className="p-3 bg-violet-50 rounded-lg" data-id="element-7069">
                  <p className="text-xs text-violet-700 mb-1" data-id="element-7070">Trigger</p>
                  <p className="text-sm font-semibold text-violet-900" data-id="element-7071">
                    Intent spike
                  </p>
                </div>
                <div className="p-3 bg-purple-50 rounded-lg" data-id="element-7072">
                  <p className="text-xs text-purple-700 mb-1" data-id="element-7073">Expected Lift</p>
                  <p className="text-sm font-semibold text-purple-900" data-id="element-7074">
                    +25-30%
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2" data-id="element-7075">
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-7076">
                  ABM
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-7077">
                  Outbound
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-7078">
                  AI-Ready
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-7079">
              <div className="flex items-start justify-between mb-4" data-id="element-7080">
                <div data-id="element-7081">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7082">
                    Product-Led to Sales Assist
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-7083">
                    In-app + Email • 6 touchpoints • 7 days
                  </p>
                </div>
                <span className="px-3 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded-full" data-id="element-7084">
                  Quick Win
                </span>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-7085">
                Convert high-usage trial accounts to sales-assisted deals when
                enterprise signals detected.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-7086">
                <div className="p-3 bg-violet-50 rounded-lg" data-id="element-7087">
                  <p className="text-xs text-violet-700 mb-1" data-id="element-7088">Trigger</p>
                  <p className="text-sm font-semibold text-violet-900" data-id="element-7089">
                    Usage spike
                  </p>
                </div>
                <div className="p-3 bg-purple-50 rounded-lg" data-id="element-7090">
                  <p className="text-xs text-purple-700 mb-1" data-id="element-7091">Expected Lift</p>
                  <p className="text-sm font-semibold text-purple-900" data-id="element-7092">
                    +30-35%
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2" data-id="element-7093">
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-7094">
                  PLG
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-7095">
                  Conversion
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-7096">
                  AI-Ready
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-7097">
              <div className="flex items-start justify-between mb-4" data-id="element-7098">
                <div data-id="element-7099">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7100">
                    Buying Group Gap Fill
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-7101">
                    Email + LinkedIn • 5 touchpoints • 21 days
                  </p>
                </div>
                <span className="px-3 py-1 bg-orange-100 text-orange-700 text-xs font-medium rounded-full" data-id="element-7102">
                  High Impact
                </span>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-7103">
                Identify and engage missing buying committee members to complete
                coverage and accelerate deals.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-7104">
                <div className="p-3 bg-violet-50 rounded-lg" data-id="element-7105">
                  <p className="text-xs text-violet-700 mb-1" data-id="element-7106">Trigger</p>
                  <p className="text-sm font-semibold text-violet-900" data-id="element-7107">
                    Missing roles
                  </p>
                </div>
                <div className="p-3 bg-purple-50 rounded-lg" data-id="element-7108">
                  <p className="text-xs text-purple-700 mb-1" data-id="element-7109">Expected Lift</p>
                  <p className="text-sm font-semibold text-purple-900" data-id="element-7110">
                    +15-20%
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2" data-id="element-7111">
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-7112">
                  ABM
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-7113">
                  Deal Acceleration
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-7114">
                  AI-Ready
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-7115">
              <div className="flex items-start justify-between mb-4" data-id="element-7116">
                <div data-id="element-7117">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7118">
                    Renewal Risk Intervention
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-7119">
                    Email + Phone • 7 touchpoints • 30 days
                  </p>
                </div>
                <span className="px-3 py-1 bg-purple-100 text-purple-700 text-xs font-medium rounded-full" data-id="element-7120">
                  Retention
                </span>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-7121">
                Proactively address at-risk customers showing negative signals
                before renewal date.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-7122">
                <div className="p-3 bg-violet-50 rounded-lg" data-id="element-7123">
                  <p className="text-xs text-violet-700 mb-1" data-id="element-7124">Trigger</p>
                  <p className="text-sm font-semibold text-violet-900" data-id="element-7125">
                    Usage drop
                  </p>
                </div>
                <div className="p-3 bg-purple-50 rounded-lg" data-id="element-7126">
                  <p className="text-xs text-purple-700 mb-1" data-id="element-7127">Expected Lift</p>
                  <p className="text-sm font-semibold text-purple-900" data-id="element-7128">
                    +15-20%
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2" data-id="element-7129">
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-7130">
                  CS
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-7131">
                  Churn Prevention
                </span>
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs" data-id="element-7132">
                  AI-Ready
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Play Categories */}
      <section className="py-24 bg-white" data-id="element-7133">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7134">
          <div className="text-center mb-16" data-id="element-7135">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7136">
              Plays by category
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-7137">
            <div className="p-6 bg-gradient-to-br from-violet-50 to-violet-100 rounded-xl border-2 border-violet-200 hover:shadow-lg transition-all" data-id="element-7138">
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7139">
                Acquisition Plays
              </h3>
              <p className="text-sm text-gray-700 mb-3" data-id="element-7140">
                Generate new pipeline and book meetings
              </p>
              <p className="text-2xl font-bold text-violet-600" data-id="element-7141">24 plays</p>
            </div>
            <div className="p-6 bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl border-2 border-purple-200 hover:shadow-lg transition-all" data-id="element-7142">
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7143">
                Conversion Plays
              </h3>
              <p className="text-sm text-gray-700 mb-3" data-id="element-7144">
                Move opportunities through pipeline
              </p>
              <p className="text-2xl font-bold text-purple-600" data-id="element-7145">18 plays</p>
            </div>
            <div className="p-6 bg-gradient-to-br from-fuchsia-50 to-fuchsia-100 rounded-xl border-2 border-fuchsia-200 hover:shadow-lg transition-all" data-id="element-7146">
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7147">
                Expansion Plays
              </h3>
              <p className="text-sm text-gray-700 mb-3" data-id="element-7148">
                Drive upsells and cross-sells
              </p>
              <p className="text-2xl font-bold text-fuchsia-600" data-id="element-7149">15 plays</p>
            </div>
            <div className="p-6 bg-gradient-to-br from-pink-50 to-pink-100 rounded-xl border-2 border-pink-200 hover:shadow-lg transition-all" data-id="element-7150">
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7151">
                Retention Plays
              </h3>
              <p className="text-sm text-gray-700 mb-3" data-id="element-7152">
                Prevent churn and increase renewals
              </p>
              <p className="text-2xl font-bold text-pink-600" data-id="element-7153">12 plays</p>
            </div>
            <div className="p-6 bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-xl border-2 border-indigo-200 hover:shadow-lg transition-all" data-id="element-7154">
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7155">
                Event Plays
              </h3>
              <p className="text-sm text-gray-700 mb-3" data-id="element-7156">
                Maximize event ROI and follow-up
              </p>
              <p className="text-2xl font-bold text-indigo-600" data-id="element-7157">8 plays</p>
            </div>
            <div className="p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl border-2 border-blue-200 hover:shadow-lg transition-all" data-id="element-7158">
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7159">
                PLG Plays
              </h3>
              <p className="text-sm text-gray-700 mb-3" data-id="element-7160">
                Convert self-serve users to paid
              </p>
              <p className="text-2xl font-bold text-blue-600" data-id="element-7161">10 plays</p>
            </div>
          </div>
        </div>
      </section>

      {/* How Plays Work */}
      <section className="py-24 bg-gray-50" data-id="element-7162">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7163">
          <div className="text-center mb-16" data-id="element-7164">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7165">
              How to use plays
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-7166">
            <div className="text-center" data-id="element-7167">
              <div className="w-16 h-16 bg-violet-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7168">
                <span className="text-2xl font-bold text-white" data-id="element-7169">1</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7170">
                Browse library
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7171">
                Find plays that match your GTM motion and goals
              </p>
            </div>
            <div className="text-center" data-id="element-7172">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7173">
                <span className="text-2xl font-bold text-white" data-id="element-7174">2</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7175">
                Customize
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7176">
                Adjust triggers, content, and timing to fit your needs
              </p>
            </div>
            <div className="text-center" data-id="element-7177">
              <div className="w-16 h-16 bg-fuchsia-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7178">
                <span className="text-2xl font-bold text-white" data-id="element-7179">3</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7180">Activate</h3>
              <p className="text-sm text-gray-600" data-id="element-7181">
                Turn on the play and let automation handle execution
              </p>
            </div>
            <div className="text-center" data-id="element-7182">
              <div className="w-16 h-16 bg-pink-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7183">
                <span className="text-2xl font-bold text-white" data-id="element-7184">4</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7185">Optimize</h3>
              <p className="text-sm text-gray-600" data-id="element-7186">
                Monitor performance and A/B test variations
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-violet-600 to-fuchsia-700 text-white" data-id="element-7187">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-7188">
          <h2 className="text-4xl font-bold mb-6" data-id="element-7189">
            Ready to deploy proven GTM plays?
          </h2>
          <p className="text-xl text-violet-100 mb-8" data-id="element-7190">
            Browse 100+ pre-built plays and start running them today
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-7191">
            <Link to="/signup" className="px-8 py-4 bg-white text-violet-600 rounded-lg hover:bg-violet-50 font-medium text-lg shadow-lg" data-id="element-7192">
              Browse Plays
            </Link>
            <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-7193">
              Talk to Sales
            </Link>
          </div>
        </div>
      </section>
    </div>;
}